import { useActiveTiers } from '@/containers/ClubPlus/hooks/useActiveTiers'

export const useTiersChart = () => {
  const { tiers } = useActiveTiers()

  return {
    tiers,
  }
}